import { StudentTicketMessage } from '@/plugins/api'
import alert from '@/plugins/alert'

/* eslint-disable no-unused-vars */
export default {
  namespaced: true,
  actions: {
    async fetchStudentTicketMessages({ commit }, options) {
      const studentTicketMessages = await StudentTicketMessage.fetch({ ...options })
      return studentTicketMessages
    },
    async fetchStudentTicketMessage({ commit }, id) {
      const studentTicketMessage = await StudentTicketMessage.fetchOne(id)
      return studentTicketMessage
    },
    async createStudentTicketMessage({ commit }, data) {
      const newMsg = await StudentTicketMessage.create(data)
      return newMsg
    },
    async updateStudentTicketMessage({ commit }, { id, ...data }) {
      const updatedStudentTicketMessage = await StudentTicketMessage.update(id, { ...data })
      return updatedStudentTicketMessage
    },
    async countStudentTicketMessages({ commit }, options) {
      try {
        return await StudentTicketMessage.count(options)
      } catch (e) {
        alert.error(e)
      }
    },
  },
}
/* eslint-disable no-unused-vars */
